<ng-template [ngIf]="disabled">
    <input type="text" class="form-control" [value]="ngModel | representanteModalidadeComercial:'nome' | uppercase" disabled="disabled" readonly="readonly">
    <p class="form-text text-muted">
        Modalidade comercial que específica a forma de atuação e vínculo com sua empresa
    </p>
</ng-template>

<ng-template [ngIf]="!disabled">
    <select
        #select
        class="form-control"
        [id]="id"
        [name]="name"
        [required]="required"
        [disabled]="disabled"
        [autofocus]="autofocus"
        [ngModel]="ngModel || ''" 
        (ngModelChange)="onChange($event ? $event : null)">
        <option value="" *ngIf="canSelectNull || (required && !ngModel)">
            {{nullLabel | uppercase}}
        </option>        
        <option *ngFor="let modalidade of modalidades" [ngValue]="modalidade.id">
            {{ modalidade.nome | uppercase }}
        </option>
    </select>
    <p class="form-text text-muted" *ngIf="ngModel">
        {{ngModel | representanteModalidadeComercial:'descricao'}}
    </p>
    <p class="form-text text-muted" *ngIf="!ngModel">
        Modalidade comercial que específica a forma de atuação e vínculo com sua empresa
    </p>
</ng-template>